import { httpClient } from './httpClient'
import type { CraftsmanDto, UpdateCraftsmanProfileRequest } from '../dto/handwerker/CraftsmanDto'
import type { CraftsmanDashboardStatsDto } from '../dto/handwerker/CraftsmanDashboardStatsDto'
import type { CreateRatingRequest, RatingDto } from '../dto/handwerker/RatingDto'
import type { CreatePlatformRatingRequest, PlatformRatingDto } from '../dto/handwerker/PlatformRatingDto'

export const craftsmanApi = {
  getMe: () => httpClient.get<CraftsmanDto>('/craftsmen/me'),
  updateMe: (request: UpdateCraftsmanProfileRequest) => httpClient.put<CraftsmanDto>('/craftsmen/me', request),
  getById: (id: number) => httpClient.get<CraftsmanDto>(`/craftsmen/${id}`),
  addRating: (craftsmanId: number, request: CreateRatingRequest) =>
    httpClient.post<RatingDto>(`/craftsmen/${craftsmanId}/ratings`, request),
  listRatings: (craftsmanId: number) => httpClient.get<RatingDto[]>(`/craftsmen/${craftsmanId}/ratings`),
  /** Landing dashboard's stat tiles - fetching this also clears the "neue Anfragen"-Badge for the
   *  next visit (see backend CraftsmanDashboardService.stats). */
  getDashboardStats: () => httpClient.get<CraftsmanDashboardStatsDto>('/craftsmen/me/dashboard'),
  /** Clears the "Neu"-Badge on the dashboard's "Meine Kontaktanfragen"-Karte. */
  markContactRequestsSeen: () => httpClient.post<void>('/craftsmen/me/contact-requests/seen'),
  /** Self-service account deletion - requires the current password as a second confirmation
   *  factor (see DeleteAccountDialog). */
  deleteMe: (password: string) => httpClient.delete<void>('/craftsmen/me', { password }),
  /** Handwerker bewertet Roofora selbst (roofora-task-036) - Gegenrichtung zu addRating. */
  ratePlatform: (request: CreatePlatformRatingRequest) =>
    httpClient.post<PlatformRatingDto>('/craftsmen/me/platform-ratings', request),
}
